import Main from './Main'
import Lista from './components/Perito'
import Novo from './components/NovoPerito'

export default [
  {
    path: 'pc-perito-vistoriador',
    name: 'policiacivil.processo.perito-vistoriador',
    component: Main,
    redirect: { name: 'policiacivil.processo.perito-vistoriador.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.perito-vistoriador.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.perito-vistoriador.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.perito-vistoriador.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/perito/routes.js